import isString from './type-checks/isString.js'

function coerceType (value) {
  let result = value

  if (Number(value) > Number.MAX_SAFE_INTEGER) result = '' + value
  else if (parseFloat(value)) result = parseFloat(value)
  else if (value === 'true') result = true
  else if (value === 'false') result = false

  return result
}

/**
 * Parse component user settings
 *
 * @param {String} input
 * @param {Object} [defaults]
 *
 * @example
 * import { parseSettings } from '@cwp/utils'
 *
 * // e.g. from <div data-settings="..."></div>
 * const settings = parseSettings('color: blue; detached; mode: minimal')
 * // { color: 'blue', detached: true, mode: 'minimal' }
 */
export default function parseSettings (input, defaults = {}) {
  const result = {}

  if (isString(input)) {
    input
      .split(';')
      // remove empty settings
      .filter(setting => !!setting.trim())
      .forEach(setting => {
        const parts = setting
          .split(':')
          .map(item => item.trim())
        const key = parts[0]
        let value = parts[1]

        if (!value) {
          value = true
        }

        result[key] = coerceType(value)
      })
  }

  return Object.assign(defaults, result)
}
